export var isArray = function(a) {
  return (!!a) && (a.constructor === Array);
};

export var isObject = function(a) {
  return (!!a) && (a.constructor === Object);
};

export var isExists = function(a) {
  return (typeof a !== 'undefined' && a !== null);
};

export var isEmptyObject = function(obj) {
  return (Object.keys(obj).length === 0);
};


// WEBPACK FOOTER //
// ./src/helpers/check_variable_types.js